import { Dispatch } from 'redux';
import { fetcher } from '../../lib/request';

const BENEFITS_SERVER = process.env.REACT_APP_BENEFITS_SERVER;
const BENEFITS_KEY = process.env.REACT_APP_BENEFITS_KEY;

export const GET_BENEFITS_REQUEST = 'GET_BENEFITS_REQUEST';
export const GET_BENEFITS_RESPONSE = 'GET_BENEFITS_RESPONSE';
export const GET_BENEFITS_ERROR = 'GET_BENEFITS_ERROR';

export const SET_BENEFITS_PAGE = 'SET_BENEFITS_PAGE';

export const setBenefitsPageAction = (page: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_BENEFITS_PAGE,
        page
    });
};

export const getBenefitsAction = (
    tariffId: number,
    rubricId: number,
    lang: string,
    page: number
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_BENEFITS_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const query = `tariff_id=${tariffId}&rubric_id=${rubricId}&lang=${lang}&page=${page}`;
        const response = await fetcher<any>(`${BENEFITS_SERVER}/api/client/v1/benefits?${query}`)
            .auth(`Basic ${BENEFITS_KEY}`)
            .json();

        setBenefitsPageAction(response.page.current_page);

        dispatch({
            type: GET_BENEFITS_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_BENEFITS_ERROR,
            error
        });
    }
};


// WEBPACK FOOTER //
// ./src/actions/Benefits/benefits.ts